import RegSuccess from './RegSuccess';

export default RegSuccess;
